import {Tab, TabItem} from '../../../components'
import {useDispatch} from 'react-redux'
import {tabChange} from '../../../components/tab/tab_slice'

import './index.css'
import {useEffect} from "react";

export const TransactionDetail = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(tabChange({path: '.'}));
    }, [])
    
    return (
        <div className='shop-detail-wrapper'>
            <Tab>
                <TabItem path={"."} name='Chi tiết giao dịch'/>
            </Tab>
        </div>
    )
}
